import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { cacheApi } from '../api/endpoints/cache';

export function useAdminCache() {
  const clearAll = useMutation({
    mutationFn: () => cacheApi.clearAll(),
    onSuccess: () => toast.success('All cache entries cleared successfully.'),
    onError: () => toast.error('Failed to clear cache.'),
  });

  const clearInstitute = useMutation({
    mutationFn: (id: number) => cacheApi.clearInstitute(id),
    onSuccess: () => toast.success('Institute cache cleared.'),
    onError: () => toast.error('Failed to clear institute cache.'),
  });

  const clearUser = useMutation({
    mutationFn: (userId: string) => cacheApi.clearUser(userId),
    onSuccess: () => toast.success('User permissions cache cleared.'),
    onError: () => toast.error('Failed to clear user cache.'),
  });

  return { clearAll, clearInstitute, clearUser };
}
